module.exports = __webpack_public_path__ + "img/cover-slot-bg.7ccc73e4.jpg";